module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.menuList), function(item, index) {
    return [_c('div', {
      key: index,
      staticStyle: {
        "text-align": "center"
      }
    }, [(item.children.length > 1) ? _c('Dropdown', {
      key: index,
      attrs: {
        "transfer": "",
        "placement": "right-start"
      },
      on: {
        "on-click": _vm.changeMenu
      }
    }, [_c('Button', {
      staticStyle: {
        "width": "70px",
        "margin-left": "-5px",
        "padding": "10px 0"
      },
      attrs: {
        "type": "text"
      }
    }, [_c('Badge', {
      attrs: {
        "dot": "",
        "count": _vm.feeMenuBadge(item)
      }
    }, [_c('Icon', {
      attrs: {
        "size": 20,
        "color": _vm.iconColor,
        "type": item.icon
      }
    })], 1)], 1), _vm._v(" "), _c('DropdownMenu', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_vm._l((item.children), function(child, i) {
      return [_c('DropdownItem', {
        key: i,
        attrs: {
          "name": child.name
        }
      }, [_c('Icon', {
        attrs: {
          "type": child.icon
        }
      }), _c('span', {
        staticStyle: {
          "padding-left": "10px"
        }
      }, [_vm._v(_vm._s(_vm.itemTitle(child)))])], 1)]
    })], 2)], 1) : _vm._e(), _vm._v(" "), (item.children.length <= 1 && (!item.menuAccess || item.menuAccess.indexOf(_vm.access) != -1)) ? _c('Dropdown', {
      key: index,
      attrs: {
        "transfer": "",
        "placement": "right-start"
      },
      on: {
        "on-click": _vm.changeMenu
      }
    }, [_c('Button', {
      staticStyle: {
        "width": "70px",
        "margin-left": "-5px",
        "padding": "10px 0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.changeMenu(item.children[0].name)
        }
      }
    }, [_c('Badge', {
      attrs: {
        "dot": "",
        "count": _vm.feeMenuBadge(item)
      }
    }, [_c('Icon', {
      attrs: {
        "size": 20,
        "color": _vm.iconColor,
        "type": item.icon
      }
    })], 1)], 1), _vm._v(" "), _c('DropdownMenu', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('DropdownItem', {
      key: 'd' + index,
      attrs: {
        "name": item.children[0].name
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon
      }
    }), _c('span', {
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_vm._v(_vm._s(_vm.itemTitle(item.children[0])))])], 1)], 1)], 1) : _vm._e()], 1)]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e5349538", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5349538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/views/main_components/sidebarMenuShrink.vue
// module id = 1324
// module chunks = 61